<template>
  <div class="messages">
    <box :title="$t('messages-list')">
      <div v-if="messages.length > 0">
        <v-data-table
          dense
          :headers="headers"
          hide-default-footer
          disable-pagination
          :items="messages"
          item-key="MessageId"
          group-by="Recipient"
          sort-desc="SentDate"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th class="group-header" :colspan="headers.length">
              <div>
                <v-icon @click="toggle"
                  >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
                {{ items[0].Recipient }}
              </div>
            </th>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <strong class="text-primary" v-if="item.ReadDate == ''">{{ item.Subject }}</strong>
                <span v-else>{{ item.Subject }}</span>
              </td>
              <td>{{ item.SentDate }}</td>
              <td>{{ item.ReadDate }}</td>
              <td class="" @click="showMessage(item)">
                <v-btn class="ma-1" block small color="primary">{{ $t("show") }}</v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
    <eos-dialog ref="dialog" />
  </div>
</template>

<script>
import EmptyList from "../../components/widget/EmptyList.vue";
import ArrayUtils from "../../utils/ArrayUtils";
export default {
  components: {
    EmptyList,
  },
  data() {
    return {
      groupMessages: [],
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: this.$t("Subject"),
          value: "Subject",
        },
        {
          text: this.$t("SentDate"),
          value: "SentDate",
        },
        {
          text: this.$t("ReadDate"),
          value: "ReadDate",
        },
        {
          text: "",
          value: "show",
        },
      ],
    };
  },
  props: { messages: Array },
  mounted() {
    //this.GetInbox();
  },
  methods: {
    GetInbox() {
      if (this.messages.length > 0) {
        var obj = ArrayUtils.groupBy(this.messages, "Sender");
        var arr = [];
        Object.keys(obj).forEach((key) => {
          var item = { key: key, group: obj[key] };
          arr.push(item);
        });
        this.groupMessages = arr;
      }
    },
    showMessage(item) {
      this.$refs.dialog.show(this.$t("message"), item.Message);
    },
  },
};
</script>

<style scoped>
.group-header {
  background: #ededed !important;
}
.bb-1{
  border-bottom: #aa1616 2px;
}

</style>